// App.jsx
import React, { useState, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/Login";
import DashboardPage from "./pages/Dashboard";
import JobsPage from "./pages/Jobs";
import TrackingPage from "./pages/Tracking";
import ReportsPage from "./pages/Reports";
import MastersPage from "./pages/Masters";
import JobDetailsPage from "./pages/JobDetails";
import CreateJobPage from "./pages/CreateJob";
import AuthProvider from "./contexts/AuthContext";
import ThemeProvider from "./contexts/ThemeContext";
import ErrorBoundary from "./components/common/ErrorBoundary";
import ProtectedRoute from "./components/common/ProtectedRoute";
import PublicRoute from "./components/common/PublicRoute";
import { Toaster } from "react-hot-toast";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate app initialization
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);


  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          {/* <NotificationProvider> */}
          <QueryClientProvider client={queryClient}>
            <Router>
              <Routes>
                {/* Public Routes - Only accessible when NOT authenticated */}
                <Route element={<PublicRoute />}>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/" element={<Navigate to="/login" replace />} />
                </Route>

                {/* Protected Routes - Only accessible when authenticated */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/jobs/create" element={<CreateJobPage />} />
                  <Route path="/jobs/:jobId" element={<JobDetailsPage />} />
                  <Route path="/tracking" element={<TrackingPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/masters" element={<MastersPage />} />
                </Route>

                {/* Fallback Route - Redirect based on authentication status */}
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>

              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: "#363636",
                    color: "#fff",
                  },
                }}
              />
            </Router>
          </QueryClientProvider>
          {/* </NotificationProvider> */}
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
